import { Base } from "./Base";

export class User extends Base {
    _id?: string;
    gender?: any;
    phone?: any;
    firstName?: string;
    lastName?: string;
    email?: string;
    // communitiesIds?: string[];
    communities?: any[];
    classes?: any[];
    hash?: string;
    salt?: string;
    registration_date?: Date;
    statusChanged?: string;
    banned?: boolean;
    userCommunities?: {
        _id: any,
        name: any
    }[]
    constructor(args: Partial<User>) {
        super(args);
    }
}